/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfEhrUsers } from '../../models/data-page-of-ehr-users';

export interface UserGetEhrUserSearch$Params {
  emrpracticeId?: string | null;
  lastName?: string | null;
  firstName?: string | null;
  pageNumber?: number;
}

export function userGetEhrUserSearch(http: HttpClient, rootUrl: string, params?: UserGetEhrUserSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfEhrUsers>> {
  const rb = new RequestBuilder(rootUrl, userGetEhrUserSearch.PATH, 'get');
  if (params) {
    rb.query('emrpracticeId', params.emrpracticeId, {});
    rb.query('lastName', params.lastName, {});
    rb.query('firstName', params.firstName, {});
    rb.query('pageNumber', params.pageNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfEhrUsers>;
    })
  );
}

userGetEhrUserSearch.PATH = '/user/EhruserSearch';
